import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { fullscreenStyled } from './lib/fullscreen-styled';

export const CloseFullscreenButton = fullscreenStyled(CloseFullscreenIcon);
